<div routerLinkActive="active" routerLink="/map" matTooltip="Enter the site">
  <img src="../../assets/logos/resolution-copper-logo.png" alt="resolution copper logo" >
  <fa-icon [icon]="faChevronRight" size="2x"></fa-icon>
</div>

<figure>
  <img class="truescape-logo" src="../../assets/logos/truescape-logo-light.png" alt="truescape-logo">
</figure>
